export default __webpack_public_path__ + "static/media/ka.6fc8e08e.jpeg";